<template>
  <v-container>
    <v-card>
      <v-card-title class="text-h8 lighten-2" style="color: white; background-color: #1976d2">
        Situação da Solicitação
      </v-card-title>
      <v-container>
        <v-card-text style="padding-bottom: 0">
          <p><strong>Solicitação N°:</strong> {{aluno?.numeroSolicitacao}}</p>
          <p><strong>CPF:</strong> {{FunctionsCommuns.formatCPF(aluno?.cpf)}}</p>
          <p><strong>Data da Solicitação:</strong> {{FunctionsCommuns.formatBRDateHora(aluno?.listHistoricoSolicitacao[0].dataSolicitacao)}}</p>
          <p><strong>Tipo de Solicitação:</strong> {{aluno?.tipoSolicitacao}}</p>
          <p><strong>Situação:</strong> {{aluno?.situacao}}</p>
          <p v-if="aluno?.motivo"><strong>Motivo:</strong> {{aluno?.motivo}}</p>
        </v-card-text>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row class="justify-end mr-4">
          <v-col :md="1" :sm="1" :xs="6" cols="6">
            <v-btn
              depressed
              block
              midle
              color="primary"
              @click="voltar"
            >
              Voltar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {router} from "@/router";
import FunctionsCommuns from "@/util/FunctionsCommuns";
const actions = mapActions('siePedidos');
const state = mapState("siePedidos", ['aluno']);
export default {
  name: 'ModalSolicitacaoAluno',
  computed: {
    FunctionsCommuns() {
      return FunctionsCommuns
    },
    ...state
  },
  mounted() {
    if(!this.aluno?.cpf){
      this.voltar()
    }
  },
  methods: {
    ...actions,
    voltar(){
      router.push("/carteira-macrorregiao/aluno/")
    }
  }
}
</script>
<style>
.v-application .grey.lighten-2{
  background-color: #1650a9 !important;
}
</style>
